import { classNamesFunction, FontSizes, HighContrastSelector, ISpinnerStyles, IStyle } from '@fluentui/react';
import { IContactUsCurrentTheme } from './theme.model';
import { IThemedProp } from './themesUI';

export interface IRequestFeedbackStyles {
  feedbackRoot: IStyle
  feedbackLayoutRoot: IStyle
  floatContainer: IStyle
  feedbackText: IStyle
  blurText: IStyle
  ratingTitle: IStyle
  ratingComponent: IStyle
  ratingText: IStyle
  ratingComponentDiv: IStyle
  textFieldContainer: IStyle
  ratingStarFrontStyles: IStyle
  ratingStarIsLarge: IStyle
  rootIsLarge: IStyle
  ratingRootStyles: IStyle
  feedbackSuccessIconStyle: IStyle
  feedbackSuccessContent: IStyle
  feedbackSuccessRoot: IStyle
  feedbackCommentWarningStyles: IStyle
  feedbackCommentTextFieldStyles: IStyle
  feedbackSubmitErrorStyles: IStyle
  feedbackSubmitBtnContainerStyles: IStyle
  feedbackChoiceGroupStyles: IStyle
  feedbackChoiceRootStyle: IStyle
  feedbackChoiceFieldStyle: IStyle
  feedbackInteractionStylesOff: IStyle
  feedbackInteractionStylesOn: IStyle
  feedbackCancelBtnStylesOn: IStyle
}
export const getRequestFeedbackStyles = (props: IThemedProp): IRequestFeedbackStyles => {
  const { theme } = props;
  return {
    feedbackRoot: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily:
        "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', sans-serif",
      fontSize: '14px',
      marginBottom: '20px',
      color: theme.palette.neutralPrimary,
    },
    feedbackLayoutRoot: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '34px',
    },
    floatContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '10px',
      color: theme.palette.neutralPrimary,
    },
    feedbackText: {
      fontSize: '14px',
      fontFamily:
        "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', sans-serif",
      paddingTop: '5px',
    },
    blurText: {
      fontSize: '14px',
      fontFamily:
        "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', sans-serif",
      paddingTop: '5px',
      color: 'transparent',
    },
    ratingTitle: {
      fontWeight: 'bold',
      marginBottom: '8px',
      color: theme.palette.neutralPrimary,
    },
    ratingComponent: {
      display: 'flex',
      minHeight: '48px',
    },
    ratingText: {
      paddingTop: '8px',
    },
    ratingComponentDiv: {
      minWidth: '130px',
    },
    textFieldContainer: {
      paddingBottom: '2px',
    },
    ratingStarFrontStyles: {
      color: theme.palette.blue,
      selectors: {
        [HighContrastSelector]: {
          color: 'Highlight',
        },
      },
    },
    ratingStarIsLarge: {
      height: '',
      flex: '1 1 0px',
      color: theme.palette.neutralPrimary,
    },
    rootIsLarge: {
      height: 'max-content',
    },
    ratingRootStyles: {
      selectors: {
        ':hover': {
          selectors: {
            '.ms-RatingStar-back': {
              color: theme.palette.blue,
            },
          },
        },
      },
    },
    feedbackSuccessIconStyle: {
      color: '#6BB700',
      marginRight: '8px',
      paddingTop: '1px',
      fontSize: '14px',
    },
    feedbackSuccessRoot: {
      display: 'flex',
      marginBottom: '16px',
    },
    feedbackSuccessContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    feedbackCommentWarningStyles: {
      display: 'flex',
      position: 'relative',
      height: '20px',
      flexDirection: 'row-reverse',
    },
    feedbackCommentTextFieldStyles: {
      marginBottom: '20px',
      marginTop: '10px',
    },
    feedbackSubmitErrorStyles: {
      color: theme.semanticColors.errorText,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: '5px',
    },
    feedbackSubmitBtnContainerStyles: {
      display: 'flex',
    },
    feedbackChoiceGroupStyles: {
      display: 'flex',
      flexDirection: 'row',
    },
    feedbackChoiceRootStyle: {
      marginRight: '10px',
      color: theme.palette.neutralPrimary,
    },
    feedbackChoiceFieldStyle: {
      selectors: {
        '::before': {
          borderColor: theme.palette.neutralPrimary,
        },
        '::after': {
          borderColor: theme.palette.blue,
        },
      },
    },
    feedbackInteractionStylesOff: {
      height: '0',
      width: '0',
      opacity: '0',
      pointerEvents: 'none',
    },
    feedbackInteractionStylesOn: {
      height: '60%',
      transition: 'opacity 1s',
      opacity: '1',
      width: '100%',
      pointerEvents: 'auto',
    },
    feedbackCancelBtnStylesOn: {
      color: theme.semanticColors.link,
      selectors: {
        ':hover': {
          color: theme.semanticColors.link,
        },
      },
    },
  };
};

export const surveyCategoriesCheckBoxStyle = (theme: IContactUsCurrentTheme) => {
  return {
    root: {
      marginBottom: '16px',
      flex: '0 50%',
    },
    text: {
      color: theme.palette.neutralPrimary,
    },
    ':hover': {
      checkbox: {
        background: theme.palette.themePrimary,
      },
      checkboxHovered: {
        background: theme.palette.themePrimary,
      },
      checkmark: {
        color: theme.semanticColors.primaryButtonText,
      },
    },
  };
};

export const feedbackCommentTextFieldStylesStyle = (theme: IContactUsCurrentTheme) => {
  return {
    fieldGroup: {
      background: theme.semanticColors.inputBackground,
      selectors: {
        '::after': {
          borderColor: theme.palette.themePrimary,
        },
      },
    },
    field: {
      color: theme.palette.neutralPrimary,
      selectors: {
        '::placeholder': {
          color: theme.palette.neutralPrimary,
        },
      },
    },
  };
};

export const feedbackSubmitButtonStyles = (theme: IContactUsCurrentTheme) => {
  return {
    root: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'window !important',
          backgroundColor: 'windowtext !important',
          borderColor: 'windowtext !important',
          forcedColorAdjust: 'none',
        },
      },
      borderColor: `${theme.palette.themeTertiary} !important`,
    },
    rootHovered: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'window !important',
          backgroundColor: 'highlight !important',
          borderColor: 'highlight !important',
        },
      },
      borderColor: `${theme.palette.blueDark} !important`,
    },
    rootDisabled: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'graytext !important',
          backgroundColor: 'window !important',
          borderColor: 'graytext !important',
          forcedColorAdjust: 'none',
        },
      },
      borderColor: theme.semanticColors.primaryButtonBorder,
      pointerEvents: 'none',
      cursor: 'not-allowed',
      filter: 'alpha(opacity=65)',
      boxShadow: 'none',
      opacity: '.65',
    },
    rootFocused: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          backgroundColor: 'windowtext !important',
        },
      },
      backgroundColor: `${theme.palette.themeDark} !important`,
      borderColor: `${theme.palette.blueDark} !important`,
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-2px',
      textDecoration: 'none',
    },
    rootPressed: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          backgroundColor: 'windowtext !important',
        },
      },
      borderColor: `${theme.palette.blueDark} !important`,
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-2px',
      textDecoration: 'none',
    },
    label: {
      fontWeight: '400',
      fontSize: '14px',
      fontFamily: 'inherit',
    },
  };
};

export const getSpinnerStyles = (): ISpinnerStyles => {
  return { label: { fontSize: '12px' } };
};

export const getRequestFeedbackClassNames = classNamesFunction<{}, IRequestFeedbackStyles>();

export interface ISharedStyles {
  fontSizeSmall: IStyle
  fontSizeMedium: IStyle
  fontSizeIcon: IStyle
  fontSizeXXLarge: IStyle
  marginBottom10px: IStyle
  paddingBottom12: IStyle
  whiteSpacePreline: IStyle
  overflowWrapBreakWord: IStyle
  overflowHidden: IStyle
  maxHeight500: IStyle
  maxHeight300: IStyle
  flexWrap: IStyle
}

export const getSharedStyles = (): ISharedStyles => {
  return {
    fontSizeSmall: {
      fontSize: FontSizes.small,
    },
    fontSizeMedium: {
      fontSize: FontSizes.medium,
    },
    fontSizeIcon: {
      fontSize: FontSizes.icon,
    },
    fontSizeXXLarge: {
      fontSize: FontSizes.xxLarge,
    },
    marginBottom10px: {
      marginBottom: '10px',
    },
    paddingBottom12: {
      paddingBottom: '12px',
    },
    maxHeight500: {
      maxHeight: '500px',
    },
    maxHeight300: {
      maxHeight: '300px',
    },
    whiteSpacePreline: {
      whiteSpace: 'pre-line',
    },
    overflowWrapBreakWord: {
      overflowWrap: 'break-word',
    },
    overflowHidden: {
      overflow: 'hidden',
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  };
};

export const getSharedStylesClassNames = classNamesFunction<{}, ISharedStyles>();
